import type { CreateCellDefConfig } from './create-cell-def';
import { createCellDef } from './create-cell-def';

export type CreateCellConfig<
  TCells extends string,
  TDefs extends string = string,
> = CreateCellDefConfig<TCells> & {
  CellDef?: TDefs;
  value?: unknown;
};

export const createCell = <TCells extends string, TDefs extends string = string>(
  Name: TCells,
  config: CreateCellConfig<TCells, TDefs> = {},
) => {
  const { CellDef, value, ..._config } = config;
  const cell = {
    Name,
    CellDef,
    ...createCellDef(_config),
  };

  if (typeof value !== 'undefined') {
    // @ts-expect-error Cell are not allowed to extend only with value.
    cell[Name] = value;
  }

  return cell;
};
